/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useImperativeHandle } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { cleanRule } from "./ruleClean";
import { normalizeRule } from "./ruleNormalize";

export const useRulesForm = (schema, ref) => {
  const methods = useForm({
    defaultValues: {
      rules: (schema?.RULES || []).map(normalizeRule),
    },
    shouldUnregister: true,
  });

  const fieldArray = useFieldArray({
    control: methods.control,
    name: "rules",
  });

  useImperativeHandle(ref, () => ({
    getCurrentRules: () =>
      methods.getValues().rules.map((r) => cleanRule({ ...r })),
  }));

  useEffect(() => {
    methods.reset({
      rules: (schema?.RULES || []).map(normalizeRule),
    });
  }, [schema?.RULES]);

  return { methods, ...fieldArray };
};
